import script from "./OnlineMessageFileContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./OnlineMessageFileContent.vue?vue&type=script&lang=ts&setup=true"

import "./OnlineMessageFileContent.vue?vue&type=style&index=0&id=3d87402e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d87402e"]])

export default __exports__